import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/facebook4.svg'
import _imports_1 from '@/assets/images/instagram2.svg'
import _imports_2 from '@/assets/images/google3.svg'
import _imports_3 from '@/assets/images/linkedin2.svg'
import _imports_4 from '@/assets/images/user-16.jpg'
import _imports_5 from '@/assets/images/user-17.jpg'
import _imports_6 from '@/assets/images/user-18.jpg'
import _imports_7 from '@/assets/images/user-19.jpg'
import _imports_8 from '@/assets/images/user-25.jpg'
import _imports_9 from '@/assets/images/user-26.jpg'
import _imports_10 from '@/assets/images/user-27.jpg'
import _imports_11 from '@/assets/images/user-28.jpg'
import _imports_12 from '@/assets/images/user-30.jpg'
import _imports_13 from '@/assets/images/user-31.jpg'
import _imports_14 from '@/assets/images/user-32.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "all-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "all-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "default-table-area style-two campaigns-table" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle border-0" }
const _hoisted_8 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "ms-m-15" }
const _hoisted_11 = { class: "ms-m-15" }
const _hoisted_12 = { class: "ms-m-15" }
const _hoisted_13 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_14 = { class: "ms-m-15" }
const _hoisted_15 = { class: "ms-m-15" }
const _hoisted_16 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_17 = { class: "ms-m-15" }
const _hoisted_18 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_19 = { class: "ms-m-15" }
const _hoisted_20 = { class: "ms-m-15" }
const _hoisted_21 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_22 = { class: "ms-m-15" }
const _hoisted_23 = { class: "ms-m-15" }
const _hoisted_24 = {
  class: "tab-pane fade",
  id: "pending-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "pending-tab",
  tabindex: "0"
}
const _hoisted_25 = { class: "default-table-area style-two campaigns-table" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table align-middle border-0" }
const _hoisted_28 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_29 = { class: "ms-m-15" }
const _hoisted_30 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_31 = { class: "ms-m-15" }
const _hoisted_32 = { class: "ms-m-15" }
const _hoisted_33 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_34 = { class: "ms-m-15" }
const _hoisted_35 = { class: "ms-m-15" }
const _hoisted_36 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_37 = { class: "ms-m-15" }
const _hoisted_38 = { class: "ms-m-15" }
const _hoisted_39 = { class: "ms-m-15" }
const _hoisted_40 = { class: "ms-m-15" }
const _hoisted_41 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_42 = { class: "ms-m-15" }
const _hoisted_43 = { class: "ms-m-15" }
const _hoisted_44 = {
  class: "tab-pane fade",
  id: "completed-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "completed-tab",
  tabindex: "0"
}
const _hoisted_45 = { class: "default-table-area style-two campaigns-table" }
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = { class: "table align-middle border-0" }
const _hoisted_48 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_49 = { class: "ms-m-15" }
const _hoisted_50 = { class: "ms-m-15" }
const _hoisted_51 = { class: "ms-m-15" }
const _hoisted_52 = { class: "ms-m-15" }
const _hoisted_53 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_54 = { class: "ms-m-15" }
const _hoisted_55 = { class: "ms-m-15" }
const _hoisted_56 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_57 = { class: "ms-m-15" }
const _hoisted_58 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_59 = { class: "ms-m-15" }
const _hoisted_60 = { class: "ms-m-15" }
const _hoisted_61 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_62 = { class: "ms-m-15" }
const _hoisted_63 = { class: "ms-m-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[108] || (_cache[108] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3\" data-v-65b60cb0><h3 class=\"mb-0\" data-v-65b60cb0>Campaigns</h3><button class=\"btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\" data-v-65b60cb0><span class=\"py-sm-1 d-block\" data-v-65b60cb0><i class=\"ri-add-line d-none d-sm-inline-block me-1\" data-v-65b60cb0></i><span data-v-65b60cb0>Add Campaigns</span></span></button></div>", 1)),
      _cache[109] || (_cache[109] = _createElementVNode("ul", {
        class: "nav nav-tabs bg-transparent border-bottom gap-2 gap-sm-5 pb-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body active",
            id: "all-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#all-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "all-tab-pane",
            "aria-selected": "true"
          }, " ALL (05) ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body",
            id: "pending-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#pending-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "pending-tab-pane",
            "aria-selected": "false"
          }, " PENDING(05) ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link p-0 bg-transparent border-0 fs-12 fw-medium text-body",
            id: "completed-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#completed-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "completed-tab-pane",
            "aria-selected": "false"
          }, " COMPLETED(07) ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Christmas Eve"),
                        _createElementVNode("span", { class: "fs-12" }, "From 10 Oct - 15 Oct, 24")
                      ])
                    ], -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, " Live Now ")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_8, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_9, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_10, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_11, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_12, [
                          _createVNode(_component_RouterLink, {
                            to: "/users/users-list",
                            class: "wh-34 lh-34 rounded-circle d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white",
                            style: {"background-color":"#3a4252"}
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" +3 ")
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Teacher’s Day"),
                        _createElementVNode("span", { class: "fs-12" }, "From 08 Oct - 12 Oct, 24")
                      ])
                    ], -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        })
                      ])
                    ], -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_14, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createElementVNode("img", {
                                src: _imports_9,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_15, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createElementVNode("img", {
                                src: _imports_10,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "ThanksGiving"),
                        _createElementVNode("span", { class: "fs-12" }, "From 01 Oct - 05 Oct, 24")
                      ])
                    ], -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-primary bg-opacity-10 rounded-2 text-primary" }, "Paused")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_16, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_17, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createElementVNode("img", {
                                src: _imports_11,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary-div ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Team Gateway"),
                        _createElementVNode("span", { class: "fs-12" }, "From 05 Oct - 17 Oct, 24")
                      ])
                    ], -1)),
                    _cache[27] || (_cache[27] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_18, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createElementVNode("img", {
                                src: _imports_12,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_19, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createElementVNode("img", {
                                src: _imports_13,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_20, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createElementVNode("img", {
                                src: _imports_14,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-success ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1 text-secondary" }, " Halloween "),
                        _createElementVNode("span", { class: "fs-12" }, "From 20 Oct - 31 Oct, 24")
                      ])
                    ], -1)),
                    _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[35] || (_cache[35] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_21, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_22, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_23, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "ThanksGiving"),
                        _createElementVNode("span", { class: "fs-12" }, "From 01 Oct - 05 Oct, 24")
                      ])
                    ], -1)),
                    _cache[40] || (_cache[40] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_28, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_29, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createElementVNode("img", {
                                src: _imports_11,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[46] || (_cache[46] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary-div ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Team Gateway"),
                        _createElementVNode("span", { class: "fs-12" }, "From 05 Oct - 17 Oct, 24")
                      ])
                    ], -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[48] || (_cache[48] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_30, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createElementVNode("img", {
                                src: _imports_12,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_31, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createElementVNode("img", {
                                src: _imports_13,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_32, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[44] || (_cache[44] = [
                              _createElementVNode("img", {
                                src: _imports_14,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[53] || (_cache[53] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-success ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1 text-secondary" }, " Halloween "),
                        _createElementVNode("span", { class: "fs-12" }, "From 20 Oct - 31 Oct, 24")
                      ])
                    ], -1)),
                    _cache[54] || (_cache[54] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[55] || (_cache[55] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_33, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[49] || (_cache[49] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_34, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_35, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[62] || (_cache[62] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Christmas Eve"),
                        _createElementVNode("span", { class: "fs-12" }, "From 10 Oct - 15 Oct, 24")
                      ])
                    ], -1)),
                    _cache[63] || (_cache[63] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_36, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_37, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[57] || (_cache[57] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_38, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_39, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[59] || (_cache[59] = [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_40, [
                          _createVNode(_component_RouterLink, {
                            to: "/users/users-list",
                            class: "wh-34 lh-34 rounded-circle d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white",
                            style: {"background-color":"#3a4252"}
                          }, {
                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                              _createTextVNode(" +3 ")
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[61] || (_cache[61] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[69] || (_cache[69] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Teacher’s Day"),
                        _createElementVNode("span", { class: "fs-12" }, "From 08 Oct - 12 Oct, 24")
                      ])
                    ], -1)),
                    _cache[70] || (_cache[70] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        })
                      ])
                    ], -1)),
                    _cache[71] || (_cache[71] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-success bg-opacity-10 rounded-2 text-success" }, "Reviewing")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_41, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[65] || (_cache[65] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_42, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[66] || (_cache[66] = [
                              _createElementVNode("img", {
                                src: _imports_9,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_43, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[67] || (_cache[67] = [
                              _createElementVNode("img", {
                                src: _imports_10,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[68] || (_cache[68] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("table", _hoisted_47, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[78] || (_cache[78] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Christmas Eve"),
                        _createElementVNode("span", { class: "fs-12" }, "From 10 Oct - 15 Oct, 24")
                      ])
                    ], -1)),
                    _cache[79] || (_cache[79] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[80] || (_cache[80] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_48, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[72] || (_cache[72] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_49, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[73] || (_cache[73] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_50, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_51, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_52, [
                          _createVNode(_component_RouterLink, {
                            to: "/users/users-list",
                            class: "wh-34 lh-34 rounded-circle d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white",
                            style: {"background-color":"#3a4252"}
                          }, {
                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                              _createTextVNode(" +3 ")
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[85] || (_cache[85] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-danger ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Teacher’s Day"),
                        _createElementVNode("span", { class: "fs-12" }, "From 08 Oct - 12 Oct, 24")
                      ])
                    ], -1)),
                    _cache[86] || (_cache[86] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        })
                      ])
                    ], -1)),
                    _cache[87] || (_cache[87] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_53, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_54, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[82] || (_cache[82] = [
                              _createElementVNode("img", {
                                src: _imports_9,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_55, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[83] || (_cache[83] = [
                              _createElementVNode("img", {
                                src: _imports_10,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[84] || (_cache[84] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[91] || (_cache[91] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "ThanksGiving"),
                        _createElementVNode("span", { class: "fs-12" }, "From 01 Oct - 05 Oct, 24")
                      ])
                    ], -1)),
                    _cache[92] || (_cache[92] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[93] || (_cache[93] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_56, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[88] || (_cache[88] = [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_57, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[89] || (_cache[89] = [
                              _createElementVNode("img", {
                                src: _imports_11,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[98] || (_cache[98] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-primary-div ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1" }, "Team Gateway"),
                        _createElementVNode("span", { class: "fs-12" }, "From 05 Oct - 17 Oct, 24")
                      ])
                    ], -1)),
                    _cache[99] || (_cache[99] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[100] || (_cache[100] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_58, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[94] || (_cache[94] = [
                              _createElementVNode("img", {
                                src: _imports_12,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_59, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[95] || (_cache[95] = [
                              _createElementVNode("img", {
                                src: _imports_13,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_60, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[96] || (_cache[96] = [
                              _createElementVNode("img", {
                                src: _imports_14,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[97] || (_cache[97] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[105] || (_cache[105] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "border-start border-2 border-success ps-3 py-2" }, [
                        _createElementVNode("h4", { class: "fs-14 fw-semibold mb-1 text-secondary" }, " Halloween "),
                        _createElementVNode("span", { class: "fs-12" }, "From 20 Oct - 31 Oct, 24")
                      ])
                    ], -1)),
                    _cache[106] || (_cache[106] = _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "d-flex gap-3 gap-xl-2 gap-xxl-3 flex-wrap" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "instagram"
                        }),
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "facebook"
                        }),
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "facebook"
                        })
                      ])
                    ], -1)),
                    _cache[107] || (_cache[107] = _createElementVNode("td", null, [
                      _createElementVNode("span", { class: "d-inline-block py-1 px-2 bg-danger bg-opacity-10 rounded-2 text-danger" }, "Live Now")
                    ], -1)),
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_61, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[101] || (_cache[101] = [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_62, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[102] || (_cache[102] = [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_63, [
                          _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                            default: _withCtx(() => _cache[103] || (_cache[103] = [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                                alt: "user"
                              }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: "/nft-marketplace/nft-details",
                        class: "rounded-circle d-inline-block text-center fs-18 hover-bg for-dark-read",
                        style: {"background-color":"#eceef2","width":"30px","height":"30px","line-height":"30px"}
                      }, {
                        default: _withCtx(() => _cache[104] || (_cache[104] = [
                          _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}